// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Json_encode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_encode.mjs";
import * as PnMStoreEn$PorterinFeature from "../store/PnMStoreEn.mjs";
import * as PnMRepoHelper$PorterinFeature from "./PnMRepoHelper.mjs";
import * as PnMShiftingType$PorterinFeature from "../types/PnMShiftingType.mjs";

function encodePnMShiftReqBasicDetailsData(form_data, shift_req_id) {
  var data = form_data.customer_details.alternate_mobile;
  var shifting_type = form_data.shifting_type;
  var tmp;
  if (shifting_type !== undefined) {
    switch (shifting_type.TAG | 0) {
      case /* Inter */0 :
          var data$1 = shifting_type._0;
          tmp = Json_encode.object_({
                hd: [
                  "type",
                  PnMShiftingType$PorterinFeature.toString(shifting_type)
                ],
                tl: {
                  hd: [
                    "pickup_geo_region_id",
                    data$1.pickup_geo_region_id
                  ],
                  tl: {
                    hd: [
                      "drop_geo_region_id",
                      data$1.drop_geo_region_id
                    ],
                    tl: /* [] */0
                  }
                }
              });
          break;
      case /* Intra */1 :
      case /* Labour */2 :
          tmp = Json_encode.object_({
                hd: [
                  "type",
                  PnMShiftingType$PorterinFeature.toString(shifting_type)
                ],
                tl: {
                  hd: [
                    "geo_region_id",
                    shifting_type._0
                  ],
                  tl: /* [] */0
                }
              });
          break;
      
    }
  } else {
    tmp = null;
  }
  return Json_encode.object_({
              hd: [
                "customer_details",
                Json_encode.object_({
                      hd: [
                        "name",
                        form_data.customer_details.name
                      ],
                      tl: {
                        hd: [
                          "mobile",
                          Json_encode.object_({
                                hd: [
                                  "number",
                                  form_data.customer_details.mobile
                                ],
                                tl: /* [] */0
                              })
                        ],
                        tl: {
                          hd: [
                            "mail_id",
                            Json_encode.nullable((function (prim) {
                                    return prim;
                                  }), form_data.customer_details.email)
                          ],
                          tl: {
                            hd: [
                              "alternate_mobile",
                              data !== undefined ? Json_encode.object_({
                                      hd: [
                                        "number",
                                        data
                                      ],
                                      tl: /* [] */0
                                    }) : null
                            ],
                            tl: /* [] */0
                          }
                        }
                      }
                    })
              ],
              tl: {
                hd: [
                  "geo_region_id",
                  Json_encode.nullable((function (prim) {
                          return prim;
                        }), form_data.geo_region_id)
                ],
                tl: {
                  hd: [
                    "shifting_ts",
                    Belt_Option.mapWithDefault(form_data.shifting_date, null, (function (x) {
                            return x.getTime();
                          }))
                  ],
                  tl: {
                    hd: [
                      "house_type",
                      form_data.house_type
                    ],
                    tl: {
                      hd: [
                        "sr_external_id",
                        Belt_Option.mapWithDefault(shift_req_id, null, (function (x) {
                                return x;
                              }))
                      ],
                      tl: {
                        hd: [
                          "opp_external_id",
                          Belt_Option.mapWithDefault(form_data.opportunity_id, null, (function (x) {
                                  return x;
                                }))
                        ],
                        tl: {
                          hd: [
                            "source",
                            form_data.source
                          ],
                          tl: {
                            hd: [
                              "shifting_type",
                              tmp
                            ],
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

function encodeLocation(form_data) {
  return Json_encode.object_({
              hd: [
                "location",
                Json_encode.object_({
                      hd: [
                        "address",
                        form_data.landmark
                      ],
                      tl: {
                        hd: [
                          "latlng",
                          Json_encode.object_({
                                hd: [
                                  "lat",
                                  form_data.location.lat
                                ],
                                tl: {
                                  hd: [
                                    "lng",
                                    form_data.location.lng
                                  ],
                                  tl: /* [] */0
                                }
                              })
                        ],
                        tl: {
                          hd: [
                            "address_components",
                            PnMRepoHelper$PorterinFeature.encodePostalAddress(form_data.extended_address)
                          ],
                          tl: /* [] */0
                        }
                      }
                    })
              ],
              tl: {
                hd: [
                  "floor",
                  0
                ],
                tl: {
                  hd: [
                    "lift_availability",
                    PnMStoreEn$PorterinFeature.noLift
                  ],
                  tl: {
                    hd: [
                      "parking_distance",
                      Json_encode.object_({
                            hd: [
                              PnMStoreEn$PorterinFeature.inMeter,
                              PnMStoreEn$PorterinFeature.defaultParkingDistance
                            ],
                            tl: /* [] */0
                          })
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

function encodePnMShiftReqAddressData(form_data, shift_req_id, source) {
  return Json_encode.object_({
              hd: [
                "sr_external_id",
                shift_req_id
              ],
              tl: {
                hd: [
                  "location_details",
                  Json_encode.object_({
                        hd: [
                          "pickup",
                          encodeLocation(form_data.pickup)
                        ],
                        tl: {
                          hd: [
                            "pickup_waypoints",
                            []
                          ],
                          tl: {
                            hd: [
                              "drop",
                              encodeLocation(form_data.drop)
                            ],
                            tl: {
                              hd: [
                                "drop_waypoints",
                                []
                              ],
                              tl: /* [] */0
                            }
                          }
                        }
                      })
                ],
                tl: {
                  hd: [
                    "source",
                    source
                  ],
                  tl: /* [] */0
                }
              }
            });
}

export {
  encodePnMShiftReqBasicDetailsData ,
  encodeLocation ,
  encodePnMShiftReqAddressData ,
}
/* PnMRepoHelper-PorterinFeature Not a pure module */
